import { mapState, mapActions } from 'vuex';

export default {
  name: 'MachineDrawerEditor',
  model: {
    type: 'input',
    prop: 'value',
  },
  props: {
    value: Boolean,
    create: Boolean,
    drawer: {
      type: Object,
      default: () => ({}),
    },
    machineName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
      internalName: '',
      capacity: 0,
      preferredSubstrate: '',
      preferredSubstrateWidth: '',
      preferredSubstrateHeight: '',
      state: 1,
    };
  },
  computed: {
    ...mapState('substrates', {
      substratesOptions: ({ allSubstrates }) => allSubstrates.map(({ name }) => ({
        value: name,
        text: name,
      })),
    }),
    nameErrorConfig() {
      return {
        error: !this.name,
        errorMessages: !this.name ? ['Field must be filled!'] : [],
      };
    },
    internalNameErrorConfig() {
      return {
        error: !this.internalName,
        errorMessages: !this.internalName ? ['Field must be filled!'] : [],
      };
    },
    capacityErrorConfig() {
      return {
        error: !`${this.capacity}`.length,
        errorMessages: !`${this.capacity}`.length ? ['Field must be filled!'] : [],
      };
    },
    isInvalidForm() {
      return this.nameErrorConfig.error
        || this.internalNameErrorConfig.error
        || this.capacityErrorConfig.error;
    },
  },
  watch: {
    create(newValue) {
      if (newValue) {
        this.resetFormData();
      }
    },
    drawer: {
      handler(newValue) {
        if (this.create) {
          return;
        }

        this.name = newValue.name;
        this.internalName = newValue.internalName;
        this.capacity = newValue.capacity;
        this.preferredSubstrate = newValue.preferredSubstrate;
        this.preferredSubstrateWidth = newValue.preferredSubstrateWidth;
        this.preferredSubstrateHeight = newValue.preferredSubstrateHeight;
        this.state = newValue.state;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('machines', ['createMachineDrawer', 'updateMachineDrawer']),
    submitMachineDrawerForm() {
      if (this.isInvalidForm) {
        return;
      }

      const action = this.create ? this.createMachineDrawer : this.updateMachineDrawer;
      this.$VBlackerTheme.alert.warning({
        text: `${this.create ? 'Create' : 'Update'} machine drawer?`,
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await action({
            machineName: this.machineName,
            currentDrawerName: this.drawer.name,
            drawer: {
              name: this.name,
              internalName: this.internalName,
              capacity: this.capacity,
              preferredSubstrate: this.preferredSubstrate || null,
              preferredSubstrateWidth: this.preferredSubstrateWidth || null,
              preferredSubstrateHeight: this.preferredSubstrateHeight || null,
              state: this.create ? null : this.state,
            },
          });
          this.$emit('success');
          this.closeEditor();
        } catch (e) {
          this.$VBlackerTheme.closeLoadingSpinner();
          this.$VBlackerTheme.notification.error(e);
        }
      });
    },
    closeEditor() {
      this.$emit('input', false);
      this.$emit('update:create', true);
      this.resetFormData();
    },
    resetFormData() {
      this.name = '';
      this.internalName = '';
      this.capacity = 0;
      this.preferredSubstrate = '';
      this.preferredSubstrateWidth = '';
      this.preferredSubstrateHeight = '';
      this.state = 1;
    },
  },
};
